import { render, staticRenderFns } from "./NavigationButtons.vue?vue&type=template&id=1532bc93&scoped=true&"
import script from "./NavigationButtons.vue?vue&type=script&lang=js&"
export * from "./NavigationButtons.vue?vue&type=script&lang=js&"
import style0 from "./NavigationButtons.vue?vue&type=style&index=0&id=1532bc93&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1532bc93",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VToolbarItems } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VDivider,VIcon,VImg,VToolbarItems})
